export const PREFERRED_TIMEZONE_OPTIONS = [
  { label: 'Alaska', value: 'Alaska' },
  { label: 'Arizona', value: 'Arizona' },
  { label: 'Central Time (US & Canada)', value: 'Central Time (US & Canada)' },
  { label: 'Eastern Time (US & Canada)', value: 'Eastern Time (US & Canada)' },
  { label: 'Hawaii', value: 'Hawaii' },
  { label: 'Mountain Time (US & Canada)', value: 'Mountain Time (US & Canada)' },
  { label: 'Pacific Time (US & Canada)', value: 'Pacific Time (US & Canada)' }
];
